import React, { useState, useEffect, useCallback, useMemo } from 'react';
import useHandleAddProduct from '../../../utils/handleAddProduct';
import { BASKET_CACHE_KEY } from '../../../utils/handleLocalStorage';
import CustomButton from '../button';
import SelectCurrency from '../selectCurrency';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../store/user';
import ShowCurrencies from '../../../utils/showCurrencies';
import services from '../../../services';
import { IoMdTime } from 'react-icons/io';
import Skeleton from 'react-loading-skeleton';
import InfoTooltip from './InfoTooltip';

function QurbanWidgetContent(props) {
  const {
    topList = [],
    bottomList = [],
    extraList = [],
    topBundleList = [],
    topBundleTitle = '',
    topBundleImage = '',
    cardTitle = '',
    cardSubTitle = '',
    topCardTitle = '',
    topCardImageBlue = '',
    topCardProductTitle = '',
    topCardProduct = [],
    topCardTitle2 = '',
    topCardImageBlue2 = '',
    topCardProduct2Title = '',
    topCardProduct2 = [],
    limitedTitle = 'Limited Stock Available!',
    limitedText = '',
    limitedImage = '',
    limitedProduct = [],
    buttonLable = 'Donate Now',
    showProductsOneRow = false,
  } = props;

  const [addProduct, editProduct, removeProduct] = useHandleAddProduct();
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const navigate = useNavigate();
  const [totalSaledLimitedProduct, setTotalSaledLimitedProduct] = useState(0);
  // --- basket + quantities state ---
  const [basket, setBasket] = useState(() => {
    const raw = localStorage.getItem(BASKET_CACHE_KEY);
    return raw ? JSON.parse(raw) : { products: [], grandTotal: 0, adminCost: 0 };
  });
  // const [basket, setBasket] = useState({
  //   products: [],
  //   grandTotal: 0,
  //   adminCost: 0,
  // });
  const [quantities, setQuantities] = useState({});
  const [hydrated, setHydrated] = useState(false);

  // state for tab-specific total
  // const [totalAmountTab, setTotalAmountTab] = useState(0);

  // --- sync from storage ---
  const hydrateFromStorage = useCallback(() => {
    const raw = localStorage.getItem(BASKET_CACHE_KEY);
    const saved = raw ? JSON.parse(raw) : { products: [], grandTotal: 0, adminCost: 0 };
    setBasket(saved);

    // rebuild quantities
    const initQ = {};
    [...topList, ...bottomList, ...topCardProduct, ...topCardProduct2, ...limitedProduct, ...extraList, ...topBundleList].forEach(item => {
      initQ[item.creator] = { quantity: 0, selected: false };
    });
    (saved.products || []).forEach(({ product, quantity }) => {
      if (product && initQ[product.creator]) {
        initQ[product.creator] = { quantity, selected: quantity > 0 };
      }
    });
    setQuantities(initQ);
    setHydrated(true);
  }, [topList, bottomList, topCardProduct, topCardProduct2, limitedProduct, extraList, topBundleList]);

  useEffect(() => {
    hydrateFromStorage();
  }, [hydrateFromStorage]);

  useEffect(() => {
    window.addEventListener('localStorageUpdated', hydrateFromStorage);
    return () => {
      window.removeEventListener('localStorageUpdated', hydrateFromStorage);
    };
  }, [hydrateFromStorage]);

  // --- derive Top-Card state so it never “flickers” ---
  const topCardState = useMemo(() => {
    return topCardProduct.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [topCardProduct, basket.products]);

  const secondCardState = useMemo(() => {
    return topCardProduct2.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [topCardProduct2, basket.products]);

  // --- derive Limited-Product state likewise ---
  const limitedState = useMemo(() => {
    return limitedProduct.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [limitedProduct, basket.products]);

  console.log(limitedState, 'limitedState');

  // --- derive topListState & columns synchronously ---
  const topListState = useMemo(() => {
    return topList.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        isAdded: !!found,
        quantity: found?.quantity || 0,
      };
    });
  }, [topList, basket.products]);

  const columns = useMemo(() => {
    const half = Math.ceil(topListState.length / 2);
    return [topListState.slice(0, half), topListState.slice(half)];
  }, [topListState]);

  // --- total amount minus adminCost ---
  // const totalAmount = useMemo(() => {
  //   const creators = new Set([
  //     ...topCardProduct,
  //     ...limitedProduct,
  //     ...topList,
  //     ...bottomList
  //   ].map(item => item.creator));
  //   const tabTotal = (basket.products || []).reduce((sum, { product, quantity }) => {
  //     if (product && creators.has(product.creator)) {
  //       const price = product[selectedCurrencyStore.toLowerCase()] || product.usd || 0;
  //       return sum + quantity * price;
  //     }
  //     return sum;
  //   }, 0);

  //   setTotalAmountTab(tabTotal);
  //   return (basket.grandTotal || 0) - (basket.adminCost || 0);
  // }, [basket]);
  const totalAmount2 = useMemo(() => {
    const creators = new Set(
      [...topCardProduct, ...topCardProduct2, ...limitedProduct, ...topList, ...bottomList, ...extraList, ...topBundleList].map(item => item.creator),
    );
    const tabTotal = (basket.products || []).reduce((sum, { product, quantity }) => {
      if (product && creators.has(product.creator)) {
        // console.log("creatords if", product)
        const price = product[selectedCurrencyStore.toUpperCase()] || product.USD || 0;
        return sum + quantity * price;
      }
      return sum;
    }, 0);
    // console.log("creatords", creators, tabTotal,basket)
    return tabTotal;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [basket]);
  }, [basket.products, selectedCurrencyStore, topCardProduct, topCardProduct2, limitedProduct, topList, bottomList, extraList, topBundleList]);

  // --- limited stock count ---
  useEffect(() => {
    if (limitedProduct.length) {
      const id = limitedProduct[0].creator;
      services
        .getLatestOrdersV3({
          products: [{ campaign: 'palestine', id, start_date: '2025-03-01', end_date: '2025-08-21' }],
          currency: selectedCurrencyStore,
        })
        .then(res => setTotalSaledLimitedProduct(res.data.data[0]?.total_count || 0))
        .catch(console.error);
    }
  }, [limitedProduct, selectedCurrencyStore]);

  // --- add / reduce ---
  const handleAddQty = useCallback(
    prd => {
      addProduct({
        product: { ...prd, quantity: 1 },
        currency: selectedCurrencyStore,
        justAddToLocalStorage: true,
      });
      hydrateFromStorage();
    },
    [addProduct, selectedCurrencyStore, hydrateFromStorage],
  );

  const handleReduceQty = useCallback(
    prd => {
      const currentQty = quantities[prd.creator]?.quantity || 0;
      if (currentQty < 2) {
        removeProduct(prd);
      } else {
        editProduct({ product: { ...prd, quantity: -1 }, currency: selectedCurrencyStore, justAddToLocalStorage: true });
      }
      hydrateFromStorage();
      // if (currentQty <= 0) return;
    },
    [editProduct, selectedCurrencyStore, quantities, hydrateFromStorage, removeProduct],
  );

  // --- UI helpers ---
  const currAmmount = (code, amt) => `${getSymbolFromCurrency(code.toLowerCase())}${amt}`;
  const handleDonateNow = () => navigate('/checkout');
  const [openDescriptionId, setOpenDescriptionId] = useState(null);
  // const [focusedCardId, setFocusedCardId] = useState(null);
  // UI handlers
  const toggleDescription = id => setOpenDescriptionId(openDescriptionId === id ? null : id);
  // const handleSelectCard = id => setFocusedCardId(id);
  const handleBlur = e => {
    // if (!e.currentTarget.contains(e.relatedTarget)) setFocusedCardId(null);
  };

  return (
    <div className="bg-white flex flex-col items-center justify-center md:p-4-" tabIndex={-1}>
      <div className="bg-transparent shadow-lg- p-2 md:p-4 w-full md:w-[648px]- min-h-fit max-w-full mx-auto ">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primaryDark mb-4">{cardTitle}</h2>
          <div dangerouslySetInnerHTML={{ __html: cardSubTitle }} />
          {/* console.log("on content", topCardState, limitedState) */}
       {topBundleList && topBundleList.length > 0 &&
  topBundleList.map(item => {
    const quantityValue = quantities[item.creator]?.quantity || 0;
    const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

    return (
      <div
        key={item.id}
        className="bg-[#CDF1FF] border border-pink rounded-lg flex flex-col items-center justify-between p-1 md:p-2 mb-2"
        tabIndex={0}
        onBlur={handleBlur}
      >
        {/* — Name + Tooltip + (optional) description — */}
        <div className="flex items-center w-full justify-between">
          <div className="flex items-center ml-1 w-full max-w-[50%] space-x-1">
            <h3 className="font-brandingBold text-primaryDark text-left decoration-[1px] mr-1 max-w-[60%]">
              {item.name}
            </h3>
            <InfoTooltip>
              {item.description}
            </InfoTooltip>
          </div>

          {/* — Image + Title underneath — */}
          <div className="flex items-center w-full justify-center">
            <div className="flex flex-col items-center">
              <img
                className="w-[80px] h-[37px] rounded"
                src={topBundleImage}
                alt={item.name}
              />
              <p className="font-brandingBold text-[13px] text-primaryDark leading-[12px] text-center decoration-[1px]">
                {/* If you have a “bundle title” or subtitle, replace the hard-coded text below */}
                {topBundleTitle || ''}
              </p>
            </div>

            {/* — Price display — */}
            <div className="flex items-center justify-center space-x-1 whitespace-nowrap">
              <span className="font-brandingBold text-primaryDark leading-[12px] text-center decoration-[1px]">
                {'= '}
              </span>
              <span className="font-brandingBold text-pink leading-[12px] text-center decoration-[1px]">
                {currAmmount(selectedCurrencyStore, price)}
              </span>
            </div>
          </div>
        </div>

        {/* — Quantity controls at bottom — */}
        <div className="flex items-center justify-end w-full mt-2 md:mt-4 [&>span]:min-w-[100px]">
          {quantityValue === 0 ? (
            <button
              className="bg-pink text-white ml-3 px-2 md:px-4 py-1.5 rounded-lg flex items-center justify-center w-full max-w-[120px]"
              onClick={() => handleAddQty(item)}
            >
              Add
            </button>
          ) : !hydrated ? (
            <Skeleton height={30} />
          ) : (
            <div className="flex-grow flex justify-center">
              <button
                className="text-pink text-[22px] md:text-[26px] font-bold px-2"
                onClick={() => handleReduceQty(item)}
              >
                –
              </button>
              <span className="border-pink text-pink text-xs md:text-sm border rounded-lg px-2 py-0.5">
                {quantityValue}
              </span>
              <button
                className="text-pink text-[22px] md:text-[26px] font-bold px-2"
                onClick={() => handleAddQty(item)}
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>
    );
  })
}

          {topCardState && topCardState.length
            ? topCardState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;
                // console.log("on content", quantityValue, hydrated)
                return (
                  <div
                    key={item.id}
                    className={`bg-[#CDF1FF] border border-pink rounded-lg justify-between flex flex-col items-center p-1 md:p-2 mb-2`}
                    tabIndex={0}
                    onBlur={handleBlur}
                  >
                    <div className="flex items-center w-full justify-between">
                     <div className="flex items-center ml-1 w-full max-w-[50%] space-x-1">
                        <h3 className={`font-brandingBold ${'text-primaryDark'} text-left decoration-[1px] mr-1 max-w-[60%]`}>{item.name}</h3>
                        <InfoTooltip className="">{item.description}</InfoTooltip>
                      </div>
                      <div className="flex items-center w-full justify-center">
                        <div className="flex items-center flex-col">
                          <img className="w-[80px] h-[37px] rounded" src={topCardImageBlue} alt="Orphans_Food" />
                          <p className={`font-brandingBold text-[13px] ${'text-primaryDark'} leading-[12px] text-center decoration-[1px]`}>
                            {topCardProductTitle}
                          </p>
                        </div>
                        <div className="flex items-center justify-center space-x-1 whitespace-nowrap">
                          <span className={`font-brandingBold ${'text-primaryDark'} leading-[12px] text-center decoration-[1px]`}>{'= '}</span>
                          <span className={`font-brandingBold text-pink leading-[12px] text-center decoration-[1px]`}>
                            {currAmmount(selectedCurrencyStore, price)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-end w-full mt-2 md:mt-4 [&>span]:min-w-[100px]">
                      {quantityValue === 0 ? (
                        <button
                          className="bg-pink text-white ml-3 px-2 md:px-4 py-1.5 rounded-lg flex items-center justify-center w-full max-w-[120px]"
                          onClick={() => handleAddQty(item)}
                        >
                          Add
                        </button>
                      ) : !hydrated ? (
                        <Skeleton height={30} />
                      ) : (
                        <div className="flex-grow flex justify-center">
                          <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleReduceQty(item)}>
                            -
                          </button>
                          <span className="border-pink text-pink text-xs md:text-sm border rounded-lg px-2 py-0.5">{quantityValue}</span>
                          <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleAddQty(item)}>
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            : ''}

          {secondCardState && secondCardState.length
            ? secondCardState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;
                // console.log("on content", quantityValue, hydrated)
                return (
                  <div
                    key={item.id}
                    className={`bg-[#CDF1FF] border border-pink rounded-lg justify-between flex flex-col items-center p-1 md:p-2 mb-2`}
                    tabIndex={0}
                    onBlur={handleBlur}
                  >
                    <div className="flex items-center w-full justify-between">
                      <div className="flex ml-1 w-full max-w-[50%]">
                        <h3 className={`font-brandingBold ${'text-primaryDark'} text-left decoration-[1px]`}>{item.name}</h3>
                        <InfoTooltip>{item.description}</InfoTooltip>
                      </div>
                      <div className="flex items-center w-full justify-center">
                        <div className="flex items-center flex-col">
                          <img className="w-[80px] h-[37px] rounded" src={topCardImageBlue2} alt="Orphans_Food" />
                          <p className={`font-brandingBold text-[13px] ${'text-primaryDark'} leading-[12px] text-center decoration-[1px]`}>
                            {topCardProduct2Title}
                          </p>
                        </div>
                        <div className="flex items-center justify-center space-x-1 whitespace-nowrap">
                          <span className={`font-brandingBold ${'text-primaryDark'} leading-[12px] text-center decoration-[1px]`}>{'= '}</span>
                          <span className={`font-brandingBold text-pink leading-[12px] text-center decoration-[1px]`}>
                            {currAmmount(selectedCurrencyStore, price)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-end w-full mt-2 md:mt-4 [&>span]:min-w-[100px]">
                      {quantityValue === 0 ? (
                        <button
                          className="bg-pink text-white ml-3 px-2 md:px-4 py-1.5 rounded-lg flex items-center justify-center w-full max-w-[120px]"
                          onClick={() => handleAddQty(item)}
                        >
                          Add
                        </button>
                      ) : !hydrated ? (
                        <Skeleton height={30} />
                      ) : (
                        <div className="flex-grow flex justify-center">
                          <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleReduceQty(item)}>
                            -
                          </button>
                          <span className="border-pink text-pink text-xs md:text-sm border rounded-lg px-2 py-0.5">{quantityValue}</span>
                          <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleAddQty(item)}>
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            : ''}
          {limitedState && limitedState.length
            ? limitedState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;
                return (
                  <div key={item.id} className={`bg-white border border-pink rounded-lg flex flex-col p-1 md:p-2`} tabIndex={0} onBlur={handleBlur}>
                    <h3 className={`font-brandingBold text-pink text-center mb-2 md:mb-4`}>{limitedTitle}</h3>
                    <div className="flex items-center w-full justify-between relative">
                      <div className="flex ml-1 w-full max-w-[50%]">
                        <h3 className={`font-brandingBold ${'text-primaryDark'} text-left decoration-[1px]`}>{limitedText}</h3>
                        <InfoTooltip>{item.description}</InfoTooltip>
                      </div>
                      <div className="flex items-center w-fit justify-center md:absolute left-1/2 md:-translate-x-1/2">
                        <div className="flex items-center flex-col pr-1">
                          <img className="max-w-[120px] h-[37px] rounded" src={limitedImage} alt="Orphans_Food" />
                        </div>
                        <div className="flex items-center justify-center space-x-1 whitespace-nowrap">
                          <span className={`font-brandingBold ${'text-primaryDark'} leading-[12px] text-center decoration-[1px]`}>{'= '}</span>
                          <span className={`font-brandingBold text-pink leading-[12px] text-center decoration-[1px]`}>
                            {currAmmount(selectedCurrencyStore, price)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center w-full justify-between mt-2 md:mt-4 relative">
                      <div className="flex items-center gap-1 font-bold text-DarkerBlue min-h-[32px]">
                        <IoMdTime className="text-pink text-xl" />
                        Only{' '}
                        <span className="text-pink whitespace-nowrap">
                          {totalSaledLimitedProduct > 4000 ? 0 : 4000 - totalSaledLimitedProduct} Left
                        </span>
                      </div>
                      <div className="flex items-center justify-end w-full">
                        {quantityValue === 0 ? (
                          <button
                            className="bg-pink text-white px-2 md:px-4 py-1.5 rounded-lg flex items-center justify-center w-full max-w-[120px]"
                            onClick={() => handleAddQty(item)}
                          >
                            Add
                          </button>
                        ) : (
                          <div className="flex items-center w-full justify-center md:absolute left-1/2 md:-translate-x-1/2">
                            <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleReduceQty(item)}>
                              -
                            </button>
                            <span className="border-pink text-pink text-xs md:text-sm border rounded-lg px-2 py-0.5">{quantityValue}</span>
                            <button className="text-pink text-[22px] md:text-[26px] font-bold px-2" onClick={() => handleAddQty(item)}>
                              +
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            : ''}

          {extraList && extraList.length > 0 && (
            <div className="mt-6 space-y-4">
              {extraList.map(item => {
                const qty = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;
                return (
                  <div key={item.id} className="w-full border border-pink rounded-lg flex items-center p-3 shadow-sm" tabIndex={0}>
                    {/* Image */}
                    <img src={item.image_link} alt={item.name} className="w-16 h-16 object-cover rounded mr-4" />

                    {/* Name + Price */}
                    <div className="flex-1">
                      <h4 className="font-brandingBold text-primaryDark">{item.name}</h4>
                      <p className="text-pink font-brandingBold">{ShowCurrencies(selectedCurrencyStore, price)}</p>
                    </div>

                    {/* Quantity controls */}
                    <div className="flex items-center">
                      {qty === 0 ? (
                        <button
                          className={`bg-pink text-white flex justify-center items-center rounded-lg px-2 h-7`}
                          onClick={e => {
                            e.stopPropagation();
                            handleAddQty(item);
                          }}
                        >
                          Add
                        </button>
                      ) : (
                        <>
                          <button
                            className="text-pink text-[25px] font-bold px-2"
                            onClick={e => {
                              e.stopPropagation();
                              handleReduceQty(item);
                            }}
                          >
                            -
                          </button>
                          <span className="border border-pink text-pink text-sm rounded-lg px-2 py-0.5">{qty}</span>
                          <button
                            className="text-pink text-[25px] font-bold px-2"
                            onClick={e => {
                              e.stopPropagation();
                              handleAddQty(item);
                            }}
                          >
                            +
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 mt-5">
            {/* {console.log("top lists=", topListState)} */}
            {topListState.length === 0 ? (
              <div className="flex justify-center items-center w-[300px] h-[200px]">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#253B7E]"></div>
              </div>
            ) : (
              columns.map((column, colIndex) => (
                <React.Fragment key={colIndex}>
                  <div className={`${showProductsOneRow ? 'col-span-2 md:col-span-1' : ''} space-y-3`}>
                    {column.map(item => {
                      const quantityValue = quantities[item.creator]?.quantity || 0;
                      const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                      return (
                        <div
                          key={item.id}
                          className={`border ${
                            openDescriptionId === item.id ? '' : 'h-[76px]- md:h-[84px]'
                          } rounded-lg flex items-center p-1 shadow-md`}
                          onClick={e => {
                            e.stopPropagation();
                            // handleSelectCard(item.id);
                          }}
                          tabIndex={0}
                          onBlur={handleBlur}
                        >
                          <div className="flex flex-col items-center w-full">
                            <div className={`flex ${showProductsOneRow ? '' : 'flex-col sm:flex-row'} items-center w-full`}>
                              <div className="flex items-center w-full sm:ml-1">
                                <img
                                  src={item.image_link}
                                  alt={item.name}
                                  className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
                                />
                                <div className="flex flex-col justify-center w-full">
                                  <div className="md:hidden self-end">
                                    <InfoTooltip>{item.description}</InfoTooltip>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <h3 className="font-brandingBold text-left text-xs sm:text-sm leading-[1.2] md:leading-[1.2] text-primaryDark ">
                                      {item.name}
                                    </h3>
                                  </div>
                                  <p
                                    className={`${
                                      showProductsOneRow ? 'hidden md:block' : ''
                                    } font-brandingBold text-xs text-pink border-pink rounded-md border px-1 w-fit mt-1`}
                                  >
                                    {ShowCurrencies(selectedCurrencyStore, Number(price))}
                                  </p>
                                </div>
                                <button
                                  onClick={e => {
                                    e.stopPropagation();
                                    toggleDescription(item.id);
                                  }}
                                  className={`${showProductsOneRow ? 'md:hidden' : 'hidden'} focus:outline-none`}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`h-5 w-5 transform transition-transform ${openDescriptionId === item.id ? 'rotate-180' : ''}`}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                              <div className="flex items-center justify-end ml-auto mt-1 sm:mt-0">
                                <p
                                  className={`${
                                    showProductsOneRow ? 'md:hidden' : 'hidden'
                                  } font-brandingBold text-xs text-pink border-pink rounded-md border px-1 w-fit mr-1`}
                                >
                                  {ShowCurrencies(selectedCurrencyStore, Number(price))}
                                </p>
                                <div className="flex items-center">
                                  {quantityValue === 0 ? (
                                    <div className="flex items-center flex-col md:gap-2">
                                      <div className="hidden sm:block">
                                        <InfoTooltip>{item.description}</InfoTooltip>
                                      </div>
                                      <button
                                        className={`bg-pink text-white flex justify-center items-center rounded-lg px-2 h-7`}
                                        onClick={e => {
                                          e.stopPropagation();
                                          handleAddQty(item, colIndex);
                                        }}
                                      >
                                        Add
                                      </button>
                                    </div>
                                  ) : (
                                    <>
                                      <button
                                        className="text-pink text-[25px] font-bold px-2"
                                        onClick={e => {
                                          e.stopPropagation();
                                          handleReduceQty(item, colIndex);
                                        }}
                                      >
                                        -
                                      </button>
                                      <span className="border border-pink text-pink text-sm rounded-lg px-2 py-0.5">{quantityValue}</span>
                                      <button
                                        className="text-pink text-[25px] font-bold px-2"
                                        onClick={e => {
                                          e.stopPropagation();
                                          handleAddQty(item, colIndex);
                                        }}
                                      >
                                        +
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {openDescriptionId === item.id && (
                              <div className="text-xs p-2 text-[#253B7E] font-branding">{item.short_description || item.description}</div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              ))
            )}
          </div>
          <div className="flex flex-col sm:flex-row py-7">
            {bottomList && bottomList.length ? (
              <div className="w-full sm:w-[70%]">
                {bottomList.map((item, index) => {
                  const quantityValue = quantities[item.creator]?.quantity || 0;
                  const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;
                  const isOdd = index % 2 === 1;
                  return (
                    <div
                      key={item.id}
                      className={`flex w-full md:whitespace-nowrap items-center justify-between mt-1 p-1 ${isOdd ? 'bg-stone-200' : ''} ${
                        quantityValue > 0 ? 'w-fit' : ''
                      }`}
                    >
                      {/* {quantityValue > 0 */}
                      <div className="flex flex-col items-start">
                        <div className='flex items-center gap-1'>
                          <h3 className="font-branding text-xs font-medium text-left decoration-[1px] text-textPrimary">{item.name}</h3>
                          <InfoTooltip>{item.description}</InfoTooltip>
                        </div>

                        <p className="font-branding text-sm decoration-[1px] font-bold text-pink">
                          {currAmmount(selectedCurrencyStore, price)} {selectedCurrencyStore.toUpperCase()}
                        </p>
                      </div>
                      <div className="flex items-center justify-center ml-1">
                        {quantityValue === 0 ? (
                          <button
                            className={`bg-pink text-white flex text-xs sm:text-sm justify-center items-center rounded-lg px-2 h-7`}
                            onClick={e => {
                              e.stopPropagation();
                              handleAddQty(item);
                            }}
                          >
                            Add
                          </button>
                        ) : (
                          <div className="flex items-center">
                            <button className="text-[#797979] text-sm font-bold md:text-lg px-2" onClick={() => handleReduceQty(item)}>
                              -
                            </button>
                            <span className="text-[10px] sm:text-xs bg-white text-[#797979] border border-[#797979] rounded-md px-1 py-0.5">
                              {quantityValue}
                            </span>
                            <button className="text-[#797979] text-sm font-bold md:text-lg px-2" onClick={() => handleAddQty(item)}>
                              +
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ''
            )}
            <div className={`w-full ${bottomList && bottomList.length ? 'sm:w-[30%]' : ''} flex justify-end mt-4 sm:mt-0`}>
              <div
                className={`w-full h-[90px] ${
                  bottomList && bottomList.length ? 'sm:w-[112px]' : 'py-3 dm:py-5'
                } sm:h-[79px]- sm:h-full rounded-lg bg-[#F6036212] bg-opacity-30 flex flex-col items-center justify-center`}
              >
                <p className="text-textPrimary font-bold text-[14px]">Total Amount</p>
                <p className="text-pink text-sm mt-1 text-[18px] font-bold">
                  {/* {currAmmount(selectedCurrencyStore, Number(totalAmount).toLocaleString('en-US', { minimumFractionDigits: 0 }))}{' '} */}
                  {currAmmount(selectedCurrencyStore, Number(totalAmount2).toLocaleString('en-US', { minimumFractionDigits: 0 }))}{' '}
                  {selectedCurrencyStore.toUpperCase()}
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap">
            <div className="basis-1/3 z-[31]">
              <SelectCurrency onChangeCurrency={e => {}} classNamePrefix="home_select" />
            </div>
            <div className="basis-2/3 flex justify-end">
              <CustomButton
                title={buttonLable}
                onClick={handleDonateNow}
                className="bg-pink w-[90%] text-white rounded-full hover:bg-primaryDark text-xs w-[30px]- h-[20px]"
              />
            </div>
          </div>
        </div>
      </div>
      {/* {showZakatButton && <div className="w-full py-2 mt-2 md:mt-4 md:pt-4">
        <CustomButton
          title={'Click here to give Zakat to Gaza'}
          onClick={() => navigate('/zakat-calculator')}
          className="!bg-LightBlue w-full text-white rounded-lg hover:bg-primaryDark text-xs h-[20px]"
        />
      </div>} */}
    </div>
  );
}

export default QurbanWidgetContent;
